import PREMIUM_CHANGE from '../../features/premium-change/constants';
import selectRawPrice from '../select-raw-price';
import type { RootState } from '../../reducers';

const selectEffectiveDateOverride = (state: RootState) =>
  selectRawPrice(state)?.useFutureEffectiveDate ? PREMIUM_CHANGE.FUTURE_EFFECTIVE_DATE : null;

export default selectEffectiveDateOverride;
